import type { ContentType } from '@/types'

export interface SidebarItem {
  label: string
  path: string
}

export interface SidebarSection {
  title: string
  items: SidebarItem[]
  grid?: boolean  // 2-column grid layout (for Program and Divisi)
}

export const SIDEBAR_SECTIONS: SidebarSection[] = [
  {
    title: "WHAT'S UP CERAH",
    items: [
      { label: 'Weekly Update (Weekly Meeting - MoM)', path: '/app/weekly-update' },
      { label: 'Kalender Event', path: '/app/kalender-event' },
      { label: 'MoM Eksternal', path: '/app/category/mom-eksternal' },
    ],
  },
  {
    title: 'SOP / GUIDELINES',
    items: [
      { label: 'SOP Keuangan', path: '/app/category/sop-keuangan' },
      { label: 'SOP Operasional', path: '/app/category/sop-operasional' },
      { label: 'SOP HRGA', path: '/app/category/sop-hrga' },
      { label: 'SOP Komunikasi', path: '/app/category/sop-komunikasi' },
      { label: 'Guidelines Lainnya', path: '/app/category/guidelines' },
    ],
  },
  {
    title: 'PROGRAM',
    grid: true,
    items: [
      { label: 'FF',    path: '/app/program/ff' },
      { label: 'HEALTH',path: '/app/program/health' },
      { label: 'CWF',   path: '/app/program/cwf' },
      { label: 'OSF',   path: '/app/program/osf' },
      { label: 'CI',    path: '/app/program/ci' },
      { label: 'TARA',  path: '/app/program/tara' },
      { label: 'SETI',  path: '/app/program/seti' },
      { label: 'EV',    path: '/app/program/ev' },
    ],
  },
  {
    title: 'DIVISI',
    grid: true,
    items: [
      { label: 'PP',      path: '/app/divisi/pp' },
      { label: 'Digital', path: '/app/divisi/digital' },
      { label: 'ME',      path: '/app/divisi/me' },
      { label: 'OPS',     path: '/app/divisi/ops' },
      { label: 'OA',      path: '/app/divisi/oa' },
      { label: 'OD',      path: '/app/divisi/od' },
    ],
  },
  {
    title: 'KNOWLEDGE CENTER',
    items: [
      { label: 'Data yang dimiliki oleh CERAH (Bank Data)', path: '/app/category/bank-data' },
      { label: 'Renstra',                       path: '/app/category/renstra' },
      { label: 'Publikasi Internal',            path: '/app/category/publikasi-internal' },
      { label: 'Materi Literasi',               path: '/app/category/materi-literasi' },
      { label: 'Peraturan dan Regulasi',        path: '/app/category/peraturan-regulasi' },
      { label: 'Database Spasial',              path: '/app/category/database-spasial' },
      { label: 'Activity Report / BTOR',        path: '/app/category/activity-report' },
      { label: 'Siaran Pers',                   path: '/app/category/siaran-pers' },
      { label: 'Infografik',                    path: '/app/category/infografik' },
      { label: 'Media Monitoring',              path: '/app/category/media-monitoring' },
      { label: 'Catatan Rapat Eksternal',       path: '/app/category/catatan-rapat' },
      { label: 'Asset Digital',                 path: '/app/category/asset-digital' },
    ],
  },
  {
    title: 'DIREKTORI & KOMUNIKASI',
    items: [
      { label: 'Direktori Kontak',    path: '/app/direktori-kontak' },
      { label: 'Media Coverage',      path: '/app/category/media-coverage' },
      { label: 'Laporan Sosial Media',path: '/app/category/laporan-sosmed' },
      { label: 'Kanal Video CERAH',   path: '/app/kanal-video' },
    ],
  },
]

// Maps sidebar category slug → content_type (for Ringkasan grouping)
export const CATEGORY_CONTENT_TYPE: Record<string, ContentType> = {
  'weekly-update':      'dokumen',
  'kalender-event':     'dokumen',
  'mom-eksternal':      'dokumen',
  'sop-keuangan':       'dokumen',
  'sop-operasional':    'dokumen',
  'sop-hrga':           'dokumen',
  'sop-komunikasi':     'dokumen',
  'guidelines':         'dokumen',
  'bank-data':          'bank_data',
  'renstra':            'dokumen',
  'publikasi-internal': 'publikasi',
  'materi-literasi':    'dokumen',
  'peraturan-regulasi': 'dokumen',
  'database-spasial':   'bank_data',
  'activity-report':    'laporan',
  'siaran-pers':        'dokumen',
  'infografik':         'infografik',
  'media-monitoring':   'media',
  'catatan-rapat':      'dokumen',
  'asset-digital':      'media',
  'media-coverage':     'media',
  'laporan-sosmed':     'laporan',
}

// Human-readable labels for category slugs
export const CATEGORY_LABELS: Record<string, string> = {
  'weekly-update':      'Weekly Update (MoM)',
  'kalender-event':     'Kalender Event',
  'mom-eksternal':      'MoM Eksternal',
  'sop-keuangan':       'SOP Keuangan',
  'sop-operasional':    'SOP Operasional',
  'sop-hrga':           'SOP HRGA',
  'sop-komunikasi':     'SOP Komunikasi',
  'guidelines':         'Guidelines Lainnya',
  'bank-data':          'Bank Data CERAH',
  'renstra':            'Renstra',
  'publikasi-internal': 'Publikasi Internal',
  'materi-literasi':    'Materi Literasi',
  'peraturan-regulasi': 'Peraturan dan Regulasi',
  'database-spasial':   'Database Spasial',
  'activity-report':    'Activity Report / BTOR',
  'siaran-pers':        'Siaran Pers',
  'infografik':         'Infografik',
  'media-monitoring':   'Media Monitoring',
  'catatan-rapat':      'Catatan Rapat Eksternal',
  'asset-digital':      'Asset Digital',
  'media-coverage':     'Media Coverage',
  'laporan-sosmed':     'Laporan Sosial Media',
}

export const CONTENT_TYPE_META: Record<ContentType, { label: string; unit: string; color: string; bg: string }> = {
  bank_data:  { label: 'Bank Data',  unit: 'Data',     color: 'text-blue-600',   bg: 'bg-blue-50' },
  dokumen:    { label: 'Dokumen',    unit: 'Dokumen',  color: 'text-cerah-teal', bg: 'bg-cerah-teal-light' },
  publikasi:  { label: 'Publikasi', unit: 'Dokumen',  color: 'text-green-600',  bg: 'bg-green-50' },
  laporan:    { label: 'Laporan',   unit: 'Laporan',  color: 'text-orange-500', bg: 'bg-orange-50' },
  infografik: { label: 'Infografik',unit: 'Infografik',color: 'text-cerah-teal',bg: 'bg-cerah-teal-light' },
  media:      { label: 'Media',     unit: 'Konten',   color: 'text-blue-500',   bg: 'bg-blue-50' },
}
